import type { SelectOption } from '../../../../../../components';
import { ProgrammeTypes } from '../../../../../Nomination';

export const AddApplicationOptions: SelectOption[] = [
  {
    label: 'Application No.',
    value: 'APPLICATION_NUMBER',
  },
];

export const AddPanelMemberOptions: SelectOption[] = [
  {
    label: 'Net ID',
    value: 'NET_ID',
  },
];

export enum PANEL_RESULT {
  SHORT_LISTED = 'SHORT_LISTED',
  FAILED = 'FAILED',
  WITHDRAWN = 'WITHDRAWN',
  PENDING = 'PENDING',
  TBD = 'TBD',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
  SHORT_LISTED_OUTSTANDING = 'SHORT_LISTED_OUTSTANDING',
  THREE_YEARS = 'THREE_YEARS',
  TWO_YEARS = 'TWO_YEARS',
  ONE_YEAR = 'ONE_YEAR',
}

export const panelResultLabelMapping: Record<PANEL_RESULT, string> = {
  [PANEL_RESULT.SHORT_LISTED]: 'shortlisted',
  [PANEL_RESULT.FAILED]: 'failed',
  [PANEL_RESULT.WITHDRAWN]: 'withdrawn',
  [PANEL_RESULT.PENDING]: 'pending',
  [PANEL_RESULT.TBD]: 'TBD (To be decided)',
  [PANEL_RESULT.NOT_ELIGIBLE]: 'not eligible',
  [PANEL_RESULT.SHORT_LISTED_OUTSTANDING]: 'shortlisted(outstanding)',
  [PANEL_RESULT.THREE_YEARS]: '3yrs from Central',
  [PANEL_RESULT.TWO_YEARS]: '2yrs from Central',
  [PANEL_RESULT.ONE_YEAR]: '1yr from Central',
};

export const offeredProgrammeMap: Partial<
  Record<ProgrammeTypes, { prog: string; duration: number }>
> = {
  [ProgrammeTypes.TWO_YEAR_FULL_TIME_MPHIL]: {
    prog: 'MPhil',
    duration: 2,
  },
  [ProgrammeTypes.THREE_YEAR_FULL_TIME_PHD]: {
    prog: 'PhD',
    duration: 3,
  },
  [ProgrammeTypes.FOUR_YEAR_FULL_TIME_PHD]: {
    prog: 'PhD',
    duration: 4,
  },
};
